<template>
  <div class="d-flex flex-column h-100 p-2 workflow__container">
    <h1 class="justify-content-center workflow__title">
      {{ $i18n.t('Workflow') }}
    </h1>
    <div class="m-2 workflow__filtered">
      {{ $i18n.t('Filtered_by_last_10_wf_task') }}
    </div>
    <div class="d-flex flex-column workflow__task overflow-auto">
      <div v-if="tasks.length" class="workflow__wall">
        <el-card
          role="button"
          shadow="hover"
          class="m-2 b-0 workflow__unfinished"
          v-for="(task, key) in orderedTasks"
          :key="key"
        >
          <div class="d-flex flex-row" @click="handleTaskClick(task.refName, task.id)">
            <span
              ><span :class="['material-icons', 'workflow__status', getTaskStyle(task.status)]">{{
                getTaskStatus(task.status)
              }}</span></span
            >
            <div class="ms-3">
              <div class="workflow__sender mb-2">{{ task.title }}</div>
              <div class="fw-light mb-2 workflow__content">{{ task.name }}</div>
              <span class="font-weight-lighter workflow__time">{{ task.createDate | dateTime }}</span>
            </div>
          </div>
        </el-card>
      </div>
      <div v-else>
        <el-empty :description="$i18n.t('no_task_to_display')"></el-empty>
      </div>
      <div class="workflow__buttons mt-auto">
        <el-button
          v-for="button in buttons"
          :key="button.name"
          class="w-100 mb-1"
          is-plain
          @click="linkGenerator(button.url)"
        >
          {{ $i18n.t(button.label) }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import listRest from '../../utils/mixin-list-rest'
import notify from '../../utils/mixin-notify'
import { get } from 'lodash'
import { formatDate, formatDateTime } from '../../filters/date'
import { formatNumber } from '../../filters/number'
import formatCurrency from '../../filters/currency'

const WF_STATUS_ASSIGNED = 1
const WF_STATUS_INPROGRESS = 2

/**
 * @class Workflow
 *
 * @description workflow component for menu - showing couple of tasks...
 */
export default {
  name: 'Workflow',
  mixins: [listRest, notify],
  props: {
    activeComponent: String,
  },
  data() {
    return {
      tasks: [],
      buttons: [
        {
          name: 'my',
          label: this.$i18n.t('my_tasks'),
          url: 'wf-mytask',
        },
        {
          name: 'common',
          label: this.$i18n.t('common_tasks'),
          url: 'wf-assign',
        },
        {
          name: 'all',
          label: this.$i18n.t('all_tasks'),
          url: 'wf-alltask',
        },
      ],
      avatar: get(this, '$CORE.avatarUrl', '/static/avatar.png'),
      updateUrlBase: '/api/ProcessBuilders/run-process?id=6113b603e8afff62d500f70c&modelID=',
      idSUser: get(this, '$CORE.params.ID_S_USER', null),
    }
  },
  async created() {
    this.tasks = await this.getTasksById()
  },
  methods: {
    async getTasksById() {
      let myAssignedTasks = (
        await this.$client.execute({
          operationId: 'Workflow_getTasksById',
          parameters: {
            id: this.idSUser,
            statusFilter: WF_STATUS_ASSIGNED,
          },
        })
      ).body
      let myInProgressTasks = (
        await this.$client.execute({
          operationId: 'Workflow_getTasksById',
          parameters: {
            id: this.idSUser,
            statusFilter: WF_STATUS_INPROGRESS,
          },
        })
      ).body
      let myTask = [...myInProgressTasks, ...myAssignedTasks]
      let tmp = []
      myTask.forEach((task) => {
        if (tmp.length < 10) {
          tmp.push({
            title: task.titlefield,
            name: task.taskname,
            createDate: task.createDate,
            status: task.fstatus,
            refName: task.idName,
            refValue: task.idValue,
            id: task.idTaskformsaggregate,
          })
        }
      })
      return tmp
    },
    getTaskStatus(status) {
      return status === WF_STATUS_ASSIGNED ? 'assignment_late' : 'assignment_ind'
    },
    getTaskStyle(status) {
      return status === WF_STATUS_INPROGRESS ? 'in-progress' : 'to-do'
    },
    handleTaskClick(name, id) {
      location.href = `${this.updateUrlBase}${id}`
    },
    linkGenerator(url) {
      window.location.href = `${window.location.protocol}//${window.location.host}/${url}/index`
    },
  },
  filters: {
    dateTime: formatDateTime,
  },
  computed: {
    orderedTasks() {
      return _.orderBy(this.tasks, 'createDate').reverse()
    },
  },
}
</script>
<style scoped lang="scss">
.workflow__title {
  color: $light1;
}
.workflow__filtered {
  color: $light1;
  font-size: x-small;
}
.workflow__status {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 35px;
  width: 35px;
  font-size: 24px;
  line-height: 24px;
  color: $white;
  border-radius: 50%;
  &.to-do {
    background-color: $danger-background-color;
    color: $danger-font-color;
  }
  &.in-progress {
    background-color: $warning-background-color;
    color: $warning-font-color;
  }
}
.workflow__buttons {
  margin-top: auto;
  padding: 5px;
  padding-top: 10px;
}
.workflow__content,
.workflow__sender {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: normal;
  width: 170px;
}
.workflow__sender {
  -webkit-line-clamp: 1;
  font-weight: 600;
}
.workflow__content {
  font-size: smaller;
  font-weight: 500;
  -webkit-line-clamp: 3;
}
.workflow__time {
  font-size: x-small;
}
.workflow__attachment {
  font-size: 12px;
  vertical-align: bottom;
}
.el-card {
  background-color: $border-color-lighter;
}
.workflow__wall {
  overflow: scroll;
}
.workflow__wall::-webkit-scrollbar {
  display: none;
}
.workflow__unfinished {
  border-right: 7px solid $danger-border-color;
}
.workflow__task {
  height: calc(100% - 50px);
}
</style>

<style lang="scss">
.workflow__container {
  .el-tabs__item {
    color: $white !important;
  }
  .el-card {
    border-radius: $border-radius;
  }
  .el-tabs__content {
    height: 100%;
  }
  .el-tabs__active-bar {
    background-color: $white;
  }
  .el-tabs__nav-wrap {
    &:after {
      background-color: $default-font-color !important;
    }
  }
}
</style>
